import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { OrderListItem } from 'reg-hub-common';
import { OrderListRepositoryService } from '../../services/order-list/order-list-repository.service';

@Component({
    selector: 'app-draft-order-list',
    templateUrl: './draft-order-list.component.html',
    styleUrls: ['./draft-order-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DraftOrderListComponent {
  @Input() data: OrderListItem[] = [];
  @Input() total: number = 0;
  @Input() loading: boolean = false;

  protected displayedColumns = [
    'referenceNumber',
    'orderTypeID',
    'jurisdiction'
  ]

  constructor(
    protected repo: OrderListRepositoryService,
    protected router: Router) { }

  protected onViewAll() {
    let params = {
      status: 'Draft',
      sortColumn: 'added',
      sortDirection: 'asc',
    }

    this.router.navigate(['/orders'], { queryParams: params })
  }
}
